/* Sockable: hide ONLY the old fundraiser selector caption in the cart.
 * Preserve affiliate tracking and all input elements; no cart API calls,
 * no changes to product-page selectors, no removal of nodes.
 * The corresponding code fields are hidden separately by theme CSS.
 */
(() => {
  const exactCaption = 'fundraising organization name (not required for fundraising sock packs)';
  const tidyText = text => String(text || '').replace(/\s+/g, ' ').trim().replace(/:$/, '').trim().toLowerCase();

  function hideCaption(root) {
    const candidates = Array.from(root.querySelectorAll('label, legend, p, span, div, dt'))
      .filter(node => !node.hidden && tidyText(node.textContent) === exactCaption);
    // Hide the outermost caption-only wrapper when available (also suppresses
    // decorative separators), never a container with other cart content.
    for (const node of candidates) {
      if (candidates.some(other => other !== node && other.contains(node))) continue;
      node.hidden = true;
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('aria-hidden', 'true');
    }
  }

  function init() {
    document.querySelectorAll('cart-drawer, cart-items').forEach(root => {
      hideCaption(root);
      // Runs before the next paint when a Shopify/app cart redraw inserts the caption.
      new MutationObserver(() => hideCaption(root)).observe(root, {
        childList: true, subtree: true, characterData: true
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();